<template>
  <b-modal
    id="documentTypeModal"
    title="Detalles del socio"
    size="xl"
    centered
    scrollable
    header-bg-variant="dark"
    v-model="modalShow"
    hide-footer
  >
      <template #modal-header="{ close }">
          <b-button size="sm" variant="outline-warning" @click="close()">
              Cerrar
          </b-button>
      </template>

    <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

    <div v-if="node !== null">
      <div v-if="node.type === 'partner'">
        <ShareholderEditPersonForm :item="node"/>
      </div>
      <div v-else-if="node.type !== 'instance'">
          <ShareholderEditForm :item="node"/>
      </div>
    </div>

  </b-modal>
</template>

<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import ShareholderEditForm from '@/components/ManagedCompanies/ShareholderDetails/Shareholder-edit-company-form.vue';
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums';
import ShareholderEditPersonForm from "@/components/ManagedCompanies/ShareholderDetails/Subject-edit-person-form.vue";

export default {
  name: 'ShareholdersDetails',

  components: {
    ShareholderEditPersonForm,
    AlertDismiss,
    ShareholderEditForm,
  },

  data() {
    return {
      node: null,
      shareholders: null,
      parentId: null,
      modalShow: false
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.OpenModalShowCompanyDetails, async (data) => {
      this.node = data.node
      this.parentId = data.id;
      this.modalShow = true

      if (this.node) {
        this.shareholders = this.node.nodes.map(async (child) => {
          return {
            ...child,
            percentage: await this.getShareholderPercentage({parentId: this.node.id, childId: child.id})
          }
        });
      }
    })
  },

  methods: {
    ...mapActions(['getShareholderPercentage'])
  }
}
</script>